
import { getPartnerBySlugOptions } from "@/services/queryOptions/partnerQueryOptions";
import { useQuery } from "@tanstack/react-query";
import { useRoute } from "wouter";

export default function usePartner() {
    const [a, params] = useRoute('/xdao/:slug');
    const [b, paramsFaucet] = useRoute('/xdao/:slug/faucet');

    const query = useQuery(getPartnerBySlugOptions(params?.slug ?? paramsFaucet?.slug));

    return query;
}
